<wiz-hgroup width="100%" height="100%" verticalAlign="center" horizontalAlign="center" padding="10px">
  <wiz-label #lblNothing [visible]="!hasTab && !hasCustomTab" [wizLabel]="'$.new.tab.notab.$'" width="50%"></wiz-label>
  <wiz-vgroup height="100%" width="50%" [visible]="hasTab" class="view-widget">
    <wiz-hgroup width="100%" height="38px" class="widget-header" [verticalAlign]="'center'" padding="10px">
      <wiz-icon>wizeoo</wiz-icon>
      <wiz-label [wizLabel]="'$.new.tab.header.label.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
      <wiz-icon [wizTooltip]="'$.common.import.$'" tooltipPlacement="left" class="image-back-orange" (click)="doAct('import')" >upload</wiz-icon>
    </wiz-hgroup>
    <wiz-tile-list
      id="allkeyme"
      width="100%"
      height="100%"
      itemHeight="90"
      itemWidth="270"
      [wizDataProvider]="tabs"
      [wizLabelField]="'label'"
      [wizItemRenderer]="renderer"
    >
    </wiz-tile-list>
  </wiz-vgroup>

  <wiz-vgroup height="100%" width="50%" [visible]="hasCustomTab" class="view-widget">
    <wiz-hgroup width="100%" height="38px" class="widget-header" [verticalAlign]="'center'" padding="10px">
      <wiz-icon>modeling-template</wiz-icon>
      <wiz-label [wizLabel]="'$.new.tab.header.custom.tabs.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
      <wiz-hgroup target="icons" width="80px" horizontalAlign="end">
        <wiz-icon [wizTooltip]="'$.common.export.$'" tooltipPlacement="left" class="image-back-orange" (click)="doAct('export')">download</wiz-icon>
      </wiz-hgroup>
    </wiz-hgroup>
    <wiz-tile-list #customList
      id="custom"
      width="100%"
      height="100%"
      itemHeight="90"
      itemWidth="270"
      [wizDataProvider]="customTabs"
      [wizLabelField]="'trsLabel'"
      [wizItemRenderer]="renderer"
      [dragEnabled]="dragEnabled"
      [dropEnabled]="dragEnabled"
      enableSelfReorder="true"
      [dragMove]="dragEnabled">
    </wiz-tile-list>
  </wiz-vgroup>
</wiz-hgroup>
